<app-page
  *ipoLet="{
    addressSearchState: (addressSearchState$ | async)!,
    opportunitiesState: (opportunitiesState$ | async)!,
    opportunityDetailsState: (opportunityDetailsState$ | async)!
  } as states"
  class="address-search-container"
>
  <div class="address-search-inner-container">
    <h1>{{ 'pageTitle' | translate }}</h1>
    <p>{{ 'pageDescription' | translate }}</p>

    <div class="search-box">
      <div class="search-tabs">
        <h2
          class="search-input-label"
          [ngClass]="{ active: searchMode === 'ADDRESS' }"
          (click)="toggleSearchMode('ADDRESS')"
        >
          {{ 'searchInputLabel' | translate }}
        </h2>
        <h2
          class="search-input-label"
          [ngClass]="{ active: searchMode === 'ACCESS_ID' }"
          (click)="toggleSearchMode('ACCESS_ID')"
        >
          {{ 'accessSearchInputLabel' | translate }}
        </h2>
      </div>
      @if (searchMode === 'ADDRESS') {
      <div class="address-search-input_container">
        <gc-dropdown-input
          class="address-search-input"
          [variant]="'search'"
          [placeholder]="'searchInputPlaceholder' | translate"
          [listItems]="(suggestions$ | async) || []"
          [noResultsString]="'noResultsFoundTitle' | translate"
          [activeItemId]="getActiveAddressId()"
          [isLoading]="
            getIsAddressLoading(
              isLoadingDuringDebounce,
              states.addressSearchState.isLoading
            )
          "
          (inputChanged)="onAddressInputChanged($event)"
          (listItemClicked)="onAddressSelected($event)"
          [disableItemFiltering]="true"
        ></gc-dropdown-input>
      </div>
      } @if (searchMode === 'ACCESS_ID') {
      <div class="address-search-input_container">
        <gc-input-field
          class="address-search-input"
          [placeholder]="'accessSearchInputPlaceholder' | translate"
          [icon]="'arrowRight'"
          [value]="searchQuery$ | async"
          (changed)="onAccessInputChange($event)"
          (iconClicked)="onAccessSearchClick()"
          (enterPressed)="onAccessSearchClick()"
        >
        </gc-input-field>
      </div>
      }
    </div>

    @if ( states.addressSearchState.isSuccess && suggestions$.getValue()?.length
    === 0 ) {
    <div class="result-container">
      <div class="search-result-message-container">
        <div class="results-message">
          <ng-container [ngTemplateOutlet]="inquirable"></ng-container>
        </div>
      </div>
    </div>
    } @if (opportunities$.getValue(); as opportunities) { @if
    (opportunities.length > 1) {
    <ipo-dropdown
      [label]="'searchSelectApartment' | translate"
      [options]="opportunities"
      [selected]="selectedOpportunity"
      [placeholder]="'searchSelectApartmentPlaceholder' | translate"
      (changed)="opportunitySelectHandler($event)"
    ></ipo-dropdown>
    }
    <div class="result-container">
      @if (opportunities.length < 1) {
      <div class="search-result-message-container">
        <ng-container [ngTemplateOutlet]="inquirable"></ng-container>
      </div>
      } @if (selectedOpportunityDetails$.getValue(); as detailedResponse) {
      <div @fadeAnimation class="search-result-message-container">
        <div class="results-message">
          @switch (detailedResponse.opportunityFiberStatus) { @case
          ('INSTALLED') {
          <h3>{{ 'installed.header' | translate }}</h3>
          <p>
            {{ 'installed.description1' | translate }}
            {{ savedSearchQuery }}
            {{ 'installed.description2' | translate }}
          </p>
          <gc-button
            [variant]="'primary'"
            (clicked)="
              redirect(redirectUrls.orderService + detailedResponse.access?.id)
            "
            >{{ 'installed.buttonText' | translate }}
          </gc-button>
          } @case ('ORDERABLE') {
          <h3>{{ 'orderable.header' | translate }}</h3>
          <p>
            {{ 'orderable.description1' | translate }}
            {{ savedSearchQuery }}
            {{ 'orderable.description2' | translate }}
          </p>
          <gc-button
            [variant]="'primary'"
            (clicked)="
              redirect(
                redirectUrls.orderService + detailedResponse.opportunity.id
              )
            "
            >{{ 'orderable.buttonText' | translate }}
          </gc-button>
          } @case ('ORDERED') {
          <h3>{{ 'ordered.header' | translate }}</h3>
          <p>
            {{ 'ordered.description1' | translate }}
            {{ savedSearchQuery }}
            {{ 'ordered.description2' | translate }}
          </p>
          <div class="button-container">
            <gc-button
              (clicked)="redirect(redirectUrls.updateContactInformation)"
              [variant]="'primary'"
              >{{ 'orderable.buttonText' | translate }}
            </gc-button>
            <gc-button
              (clicked)="redirect(redirectUrls.genericServiceSupply)"
              [variant]="'secondary'"
              >{{ 'genericSupplyButton' | translate }}
            </gc-button>
          </div>
          } @case ('ORDERED_MDU') {
          <h3>{{ 'orderedMdu.header' | translate }} {{ savedSearchQuery }}</h3>
          <p>
            {{ 'orderedMdu.description1' | translate }}
            {{ 'orderedMdu.description2' | translate }}
          </p>
          <div class="button-container">
            <gc-button
              (clicked)="redirect(redirectUrls.genericServiceSupply)"
              [variant]="'secondary'"
              >{{ 'genericSupplyButton' | translate }}
            </gc-button>
          </div>
          } @case ('INQUIRABLE') {
          <ng-container [ngTemplateOutlet]="inquirable"></ng-container>
          } @case ('INQUIRED') {
          <h3>{{ 'inquired.header' | translate }}</h3>
          <p>
            {{ 'inquired.description1' | translate }}
            {{ savedSearchQuery }}
            {{ 'inquired.description2' | translate }}
          </p>
          } @case ('CANCELLED') {
          <h3>{{ 'cancelled.header' | translate }}</h3>
          <p>
            {{ 'cancelled.description1' | translate }}
            {{ savedSearchQuery }}
            {{ 'cancelled.description2' | translate }}
          </p>
          } @default {
          <ng-container [ngTemplateOutlet]="inquirable"></ng-container>
          } }
        </div>
      </div>
      }
    </div>
    } @if ( states.opportunitiesState.isLoading ||
    states.opportunityDetailsState.isLoading ) {
    <gc-loading-spinner
      @fadeAnimation
      [pixelSize]="50"
      class="results-loading"
    ></gc-loading-spinner>
    }
  </div>
</app-page>

<ng-template #inquirable>
  <h3>{{ 'inquirable.header' | translate }}</h3>
  <p>
    {{ 'inquirable.description1' | translate }}
    {{ savedSearchQuery }}
    {{ 'inquirable.description2' | translate }}
    <br />
  </p>
  <div class="button-container">
    <gc-button
      (clicked)="redirect(redirectUrls.noticeOfInterest)"
      [variant]="'secondary'"
      >{{ 'inquirable.buttonText' | translate }}
    </gc-button>
    <gc-button
      (clicked)="redirect(redirectUrls.genericServiceSupply)"
      [variant]="'primary'"
      >{{ 'genericSupplyButton' | translate }}
    </gc-button>
  </div>
</ng-template>
